import axios from "axios";

const endpoint_url = "/message/messageAudience/detail";

const getAudienceDetail = (audienceUuid) => {
  const params = new URLSearchParams([['audience_uuid', audienceUuid]]);

  return new Promise((resolve, reject) => {
    axios
      .get(endpoint_url, { params })
      .then((response) => resolve(response))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default getAudienceDetail;
